<template lang="html">
  <footer id="footer">
		<div class="container med-container">
			<div class="row align-items-center">
				<div class="col-lg-4 col-xl-5 col-logo">
					<router-link to="/">
						<img src="public/images/logo-white.svg">
					</router-link>
				</div>

				<div class="col-lg-8 col-xl-7 col-menus">
					<div class="row">
						<div class="col-sm-4 col-menu">
							<h6 class="mb-2 mb-sm-3 subtitle">Enlaces</h6>

							<p class="mb-1">
								<router-link to="/">Inicio</router-link>
							</p>
							<p class="mb-1">
								<router-link to="/#/" v-scroll-to="'#e-c'">Características</router-link>
							</p>
							<p>
								<router-link to="/#/" v-scroll-to="'#e-b'">Beneficios</router-link>
							</p>
						</div>

						<div class="col-sm-4 col-menu">
							<h6 class="mb-2 mb-sm-3 subtitle">Legal</h6>

							<p class="mb-1">
								<router-link to="/terminos-y-condiciones">Términos y condiciones</router-link>
							</p>
							<p class="mb-1">
								<router-link to="/aviso-de-privacidad">Aviso de privacidad</router-link>
							</p>
						</div>

						<div class="col-sm-4 col-menu">
							<h6 class="mb-2 mb-sm-3 subtitle">Legal</h6>

							<p class="mb-1">
								<a to="">info@tipsong.com</a>
							</p>
						</div>
					</div>
				</div>

				<div class="col-12 col-copy">
					<hr />

					<p>
						© {{ currentYear }} TIPSONG. Todos los derechos reservados.
					</p>
				</div>
			</div>
		</div>
  </footer>
</template>

<script>
export default {
	data() {
		return {
			currentYear: 0,
		}
	},

	beforeMount() {
    this.currentYear = new Date().getFullYear();
  },
}
</script>
